<template>
    <b-table
        ref="tabela"
        :items="dados"
        :fields="fields"
        striped
        small
        responsive="sm"
        :selectable="configTable.selectable"
        :select-mode="configTable.modeSelect"
        :busy="configTable.load"
        :per-page="configTable.perPage"
        :current-page="configTable.currentPage"
        show-empty
        @row-selected="onRowSelected"
        > 
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">{{ configTable.msgEmpty }}</p>
        </template>
        <template slot="numeroCnpj" slot-scope="row">
            {{ row.item.numeroCnpj ? row.item.numeroCnpj : '' | cpfCnpj }}
        </template>
        <template slot="numeroCnpjRaiz" slot-scope="row">
            {{ row.item.numeroCnpjRaiz ? row.item.numeroCnpjRaiz : '' | cnpjRaiz }}
        </template>
        <template slot="numeroCpf" slot-scope="row">
            {{ row.item.numeroCpf ? row.item.numeroCpf : '' | cpfCnpj }}
        </template>
        <template slot="situacao" slot-scope="row">
            {{ row.item.indAtivo ? 'ATIVO' : 'INATIVO' }}
        </template>
        <template slot="valorAjuizamento" slot-scope="row">
            {{ row.item.valorAjuizamento.toLocaleString() }}
        </template>
        <template slot="excluir" slot-scope="row">
            <i class="fa fa-times" style="cursor: pointer" @click.prevent="excluir(row.item)" />
        </template>
    </b-table>
</template>

<script>
export default {
    props: ['dados', 'fields', 'configTable'],
    methods: {
        excluir(item) {
            this.$emit('excluir', item)
        },
        onRowSelected(item) {
            this.$emit('editarItem', item[0])
        },
    },
    watch: {
        limpar() {
            if(this.configTable.limpar) {
                this.$refs.tabela.clearSelected()
                this.configTable.limpar = false
            }
        }
    },
    computed: {
        limpar() {
            return this.configTable.limpar
        }
    }
       

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
